import {
  SENSEMAKER_TABLE,
  sensemakerTableActionsBodyCellSx,
  sensemakerTableActionsHeaderCellSx,
  sensemakerTableBodyCellSx,
  sensemakerTableHeaderCellSx,
} from '@/shared/table/sensemaker-table-theme'

/** Figma `5106:9975` — Admin dashboard Recent Campaigns table tokens. */

export const RECENT_CAMPAIGNS_TABLE = {
  ...SENSEMAKER_TABLE,
  nameColor: SENSEMAKER_TABLE.primaryTextColor,
  dateColor: SENSEMAKER_TABLE.secondaryTextColor,
  actionBtnSize: 34,
  actionBtnRadius: '6px',
  actionGap: '12px',
  actionLaunchBg: '#e5d8fb',
  actionAnalyticsBg: '#c7ebf9',
  actionContinueBg: '#c4d9fc',
  /** Figma `5106:9975` — column width hints on ~1190px table. */
  colNameWidth: '36%',
  colStatusWidth: '18%',
  colDateWidth: '18%',
  colActionsWidth: '28%',
  colActionsMinWidth: 201,
} as const

export {
  sensemakerTableHeaderCellSx as recentCampaignsHeaderCellSx,
  sensemakerTableBodyCellSx as recentCampaignsBodyCellSx,
}

export const recentCampaignsActionsHeaderCellSx = sensemakerTableActionsHeaderCellSx({
  width: RECENT_CAMPAIGNS_TABLE.colActionsWidth,
  minWidth: RECENT_CAMPAIGNS_TABLE.colActionsMinWidth,
})

export const recentCampaignsActionsBodyCellSx = sensemakerTableActionsBodyCellSx({
  width: RECENT_CAMPAIGNS_TABLE.colActionsWidth,
  minWidth: RECENT_CAMPAIGNS_TABLE.colActionsMinWidth,
})
